export default __webpack_public_path__ + "0e1045cfeaff962c2bd5544ebe911ca9.svg";